module.exports = __webpack_public_path__ + "b9e4b5b58a4a2472b9d3ebcacf962ff4.png";